import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import AddAboutMeModal from "../../CompleteYourProfile/components/AddAboutMeModal";

const AddEditAboutMe = ({
  description,
  refetchMe,
  isFreelanceCompanyOwner,
  className = "mt-6 border-b pb-6",
}) => {
  const [isAddAboutMeModalOpen, setIsAddAboutMeModalOpen] = useState(false);
  return (
    <div className={className}>
      <div className="bg-light px-4 py-2 rounded-md flex justify-between items-center ">
        <h6 className="text-dark font-normal">{isFreelanceCompanyOwner ? "Company Capabilities/Coverage" : "About Me"}</h6>
        <i
          className="fa-light fa-pencil text-gray-900 cursor-pointer"
          onClick={() => setIsAddAboutMeModalOpen(true)}
        ></i>
      </div>
      <div className="ql-editor !min-h-0 px-4 pt-3" dangerouslySetInnerHTML={{ __html: description }} />

      {isAddAboutMeModalOpen && (
        <AddAboutMeModal
          open={isAddAboutMeModalOpen}
          close={setIsAddAboutMeModalOpen}
          description={description}
          refetchMe={refetchMe}
        />
      )}
    </div>
  );
};

export default AddEditAboutMe;
